import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BehaviorSubject } from 'rxjs';
import { StreamUtils } from './utils/stream-utils.js';
export var StreamStateSubject = /*#__PURE__*/function (_BehaviorSubject) {
  _inherits(StreamStateSubject, _BehaviorSubject);
  var _super = _createSuper(StreamStateSubject);
  function StreamStateSubject() {
    _classCallCheck(this, StreamStateSubject);
    return _super.apply(this, arguments);
  }
  _createClass(StreamStateSubject, [{
    key: "next",
    value: function next(_next) {
      var current = this.value;
      if (!StreamUtils.statesEqual(current, _next)) {
        _get(_getPrototypeOf(StreamStateSubject.prototype), "next", this).call(this, _next);
      }
    }
  }]);
  return StreamStateSubject;
}(BehaviorSubject);